export type ListFilterValue = string | string[]

export type ListQueryParams = {
  page?: number
  pageSize?: number
  sort?: string
  search?: string
  filters?: Record<string, Partial<Record<string, ListFilterValue>>>
}

/** Serializa el contrato compartido de listados sin depender del feature consumidor. */
export function buildListQueryString(params: ListQueryParams): string {
  const searchParams = new URLSearchParams()
  if (params.page) searchParams.set('pagination[page]', String(params.page))
  if (params.pageSize) searchParams.set('pagination[pageSize]', String(params.pageSize))
  if (params.sort) searchParams.append('sort', params.sort)
  if (params.search) searchParams.set('search', params.search)

  for (const [field, operators] of Object.entries(params.filters ?? {})) {
    for (const [operator, value] of Object.entries(operators ?? {})) {
      if (value === undefined || value === null || value === '') continue
      const key = `filters[${field}][${operator}]`
      if (Array.isArray(value)) {
        for (const item of value) searchParams.append(key, item)
      } else {
        searchParams.set(key, value)
      }
    }
  }
  return searchParams.toString()
}
